import { getUserManager } from "../auth/auth";
import { user } from "../auth/user";

export const credentials = user;

export function login() {
   return getUserManager().signinRedirect();
}

export function logout() {
    return getUserManager().signoutRedirect();
}

export function doSignOut() {
    logout();
}